import React from "react";
import {selectUser} from "api/firebase";
import {ThemeProvider} from "@material-ui/core";
import {useCurrentShow} from "hooks";
import {useGenerateThemeFromBranding} from "view/apps/Exhibitor/helpers";
import BubbleChat from "view/components/Chat/components/BubbleChat";
import useExhibitorPair from "hooks/useExhibitorPair";
import useBranding from "store/branding/branding.store";
import {Roles, ShowExhibitorChatMode} from "@evennt-tech/api-v2-core";
import PageChat from "./components/PageChat";

type ChatProps = {
  type: "page" | "bubble";
  showId: string;
  userRole: Roles;
  exhibitorPairId?: string;
};
const Chat = ({showId, type, userRole, exhibitorPairId}: ChatProps) => {
  const uid = selectUser()?.id;
  const {brandings} = useBranding();
  const exhibitorShowTheme = useGenerateThemeFromBranding(brandings[showId]);
  const [show] = useCurrentShow();

  const [exhibitorPair] = useExhibitorPair({
    showId,
    exhibitorPairId,
  });

  const isExhibitor = userRole === Roles.EXHIBITOR;

  const shouldIgnoreRender =
    !show ||
    (isExhibitor &&
      show.exhibitorChatMode !== ShowExhibitorChatMode.MessagingBoard);
  if (shouldIgnoreRender) {
    return null;
  }

  if (type === "page" && uid) {
    return <PageChat showId={showId} userId={uid} userRole={userRole} />;
  }

  const isExhibitorView =
    type === "bubble" && isExhibitor && uid && exhibitorPair;
  if (isExhibitorView) {
    return (
      <ThemeProvider theme={exhibitorShowTheme}>
        <BubbleChat
          showId={showId}
          userId={uid}
          userRole={userRole}
          exhibitorPair={exhibitorPair}
        />
      </ThemeProvider>
    );
  }

  return null;
};

export default Chat;
